
export const PAYMENT_ESEWA = 'esewa';
export const PAYMENT_KHALTI = 'khalti';
export const PATH_ESEWA_PAYMENT = 'https://esewa.com.np/epay/main'
// https://esewa.com.np
//https://uat.esewa.com.np